module.exports = __webpack_public_path__ + "static/media/img_splash3.72b6ff35.png";